<template>
    <div>
        <h3 class="mb-3">{{ $t('profile-image') }}</h3>
        
        <div class="input-group">
            <input hidden type="file" id="customFile" accept="image/*" ref="profileImage" @input="selectImage">
            <label class="form-control rounded-left" for="customFile" style="cursor: pointer;">
                {{ imageFilename ? imageFilename : $t('choose-file') }}
            </label>
            <div class="input-group-append"><span class="input-group-text"><b-icon icon="card-image" /></span></div>
        </div>

        <img 
            v-if="imageUrl" 
            :src="imageUrl" 
            :alt="$t('profile-image')" 
            class="d-block my-3 rounded border" 
            style="width: clamp(50px, 100%, 300px); object-fit: contain; 
            object-fit: contain;"
        />

        <img 
            v-else-if="hasAvatar"
            :src="`${this.$settings.APIBaseURL}/asset/avatar/${this.userId}?username=${this.$UserSession.getValue('username')}&authToken=${this.$UserSession.getValue('authToken')}`" 
            class="d-block my-3 rounded border bg-white" 
            style="width: clamp(50px, 100%, 300px); object-fit: contain;"
            @onerror="hasAvatar = false"
        />

        <button :disabled="!imageUrl" class="btn btn-primary" @click="uploadImage">{{  $t('upload-image') }}</button>
    </div>
</template>

<script>
export default {
    props: {
        userId: Number,
    },
    data() {
        return {
            imageFilename: '',
            imageFile: undefined,
            imageUrl: undefined,
            hasAvatar: true,
            submitting: false,
        }
    },
    methods: {
        async selectImage(event) {
            const pathParts = event.target.value.split('\\')
            this.imageFilename = pathParts[pathParts.length - 1]
            this.imageFile = event.target.files[0]

            const reader = new FileReader()
            reader.onload = () => { this.imageUrl = reader.result }
            reader.readAsDataURL(this.imageFile)
        },
        async uploadImage() {
            if (!this.imageFile || this.submitting) return

            this.submitting = true

            try {
                let data = new FormData();
                data.append("username", this.$UserSession.getValue.call(this, "username"))
                data.append("authToken", this.$UserSession.getValue.call(this, "authToken"))
                data.append("user_id", this.userId)
                data.append("file", this.imageFile)

                const res = await fetch(`${this.$settings.APIBaseURL}/users/updateprofileimage`, {
                    method: 'POST',
                    body: data,
                })

                const apiResponse = await res.json();

                const success = apiResponse.status === 'SUCCESS'

                this.$store.commit('openDialog', {
                    title: success ? this.$t('image-saved') : this.$t('something-went-wrong'),
                    content: success ? this.$t('image-saved-message') : this.$t('image-save-failed'),
                    confirmCallBack: function () {} 
                })
            } catch (err) {
                this.$log.error.call(this, err)
            } finally {
                this.submitting = false
            }
        },
    },
}
</script>